import * as core from '../../../../../../../core'
import * as rpNymc from '../rp-nymc'

export const RESOURCE = {
  payload: {
    alias: 'explore',
    appAlias: rpNymc.RESOURCE.payload.alias,
    description:
      'Explore to understand every aspect of your research enterprise',
    display: {
      isMain: true,
      position: 2,
    },
    name: 'Explore',
    page: { alias: 'rp:explore' },
  },
  type: core.quiver.Resource.Type.AppPage,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.AppPage>
